import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import Sandbox from '@/components/sandbox.vue';
import { ref, computed } from 'vue';
import { useCreditStore } from '@/stores/modules/credit';
export default /*#__PURE__*/ _defineComponent({
    __name: 'register-privacy-popup',
    props: {
        value: Boolean,
        type: {
            validator: function(val) {
                return [
                    'user',
                    'privacy',
                    'data'
                ].includes(val);
            },
            default: 'data'
        }
    },
    emits: [
        "input"
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        var creditStore = useCreditStore();
        var popupTitle = computed(function() {
            return props.type === 'user' ? 'Acuerdo de Usuario' : props.type === 'privacy' ? 'Aviso de Privacidad' : props.type === 'data' ? 'Declaración de Divulgación' : '';
        });
        var agreementUrl = ref('');
        var onOpenedPopup = function() {
            // console.log(process.env.VUE_APP_PREFIX, 1);
            // if (props.type === 'user') {
            //   agreementUrl.value = `${window.location.origin}${process.env.VUE_APP_PREFIX}protocol/agreement?type=1`;
            // } else if (props.type === 'privacy') {
            //   agreementUrl.value = `${window.location.origin}${process.env.VUE_APP_PREFIX}protocol/agreement?type=2`;
            // } else if (props.type === 'data') {
            //   agreementUrl.value = `${window.location.origin}${process.env.VUE_APP_PREFIX}protocol/agreement?type=4`;
            // }
            if (props.type === 'user') {
                var _creditStore_dictionary;
                agreementUrl.value = (_creditStore_dictionary = creditStore.dictionary) === null || _creditStore_dictionary === void 0 ? void 0 : _creditStore_dictionary.signUpLink;
            } else if (props.type === 'privacy') {
                var _creditStore_dictionary1;
                agreementUrl.value = (_creditStore_dictionary1 = creditStore.dictionary) === null || _creditStore_dictionary1 === void 0 ? void 0 : _creditStore_dictionary1.privacyLink;
            } else if (props.type === 'data') {
                var _creditStore_dictionary2;
                agreementUrl.value = (_creditStore_dictionary2 = creditStore.dictionary) === null || _creditStore_dictionary2 === void 0 ? void 0 : _creditStore_dictionary2.reportPageLink;
            }
        };
        return {
            __sfc: true,
            creditStore: creditStore,
            props: props,
            popupTitle: popupTitle,
            emit: emit,
            agreementUrl: agreementUrl,
            onOpenedPopup: onOpenedPopup,
            Sandbox: Sandbox
        };
    }
});
